import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Upload, Shield, Zap } from "lucide-react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <nav className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-bold text-gray-900">
              RedacQT
            </Link>
            
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <Link to="/who-we-are">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Who We Are
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/support">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Support
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/login">
                    <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                      Login
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>
      </nav>

      <div className="max-w-6xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          <div className="space-y-2">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              RedacQT
            </h1>
            <p className="text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
              The Smartest Way to Protect Sensitive Information.  Redact, Encrypt, and Secure Documents with Quantum Precision.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm">
              <Upload className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Easy Upload</h3>
              <p className="text-sm text-gray-500 text-center">
                Drag & drop functionality with progress tracking
              </p>
            </div>

            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm">
              <Shield className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Secure Storage</h3>
              <p className="text-sm text-gray-500 text-center">
                Enterprise-level security for your files
              </p>
            </div>

            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-sm">
              <Zap className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-lg font-semibold">Fast Processing</h3>
              <p className="text-sm text-gray-500 text-center">
                Lightning-fast upload and processing speeds
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <p className="text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
              Get Started Today!
            </p>
           </div> 
           <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/signup">
              <Button size="lg" className="w-full sm:w-auto">
                Get Started
              </Button>
            </Link>
            <Link to="/login">
              <Button variant="outline" size="lg" className="w-full sm:w-auto">
                Already have an account? Login here
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
